import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-pagos',
  templateUrl: './main-pagos.component.html',
  styleUrls: ['./main-pagos.component.css']
})
export class MainPagosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
